export const SKINS = [
  "color",
  "mono",
  "matrix",
  "dracula",
  "alien",
  "y2k",
  "neoy2k",
  "aquarium",
  "winamp",
  "macos",
];

export const SKIN_LABELS = {
  color: "Slowed",
  mono: "Dark",
  winamp: "Winamp 2.0",
  macos: "Classic Mac",
  y2k: "Y2K",
  neoy2k: "Neo-Y2K",
  matrix: "Matrix",
  aquarium: "Aquarium",
  dracula: "Dracula",
  alien: "Alien",
};

export function resolveSkin(config) {
  // Retired WMP look: keep stored `winxp` readable without applying it.
  if (config?.skinPreference === "winxp") return "color";
  if (SKINS.includes(config?.skinPreference)) return config.skinPreference;

  // Pre-skin installs stored a binary light/dark preference.
  if (config?.darkModePreference === "dark") return "mono";
  if (config?.darkModePreference === "light") return "color";
  if (config?.darkMode === true) return "mono";

  return "color";
}

export function nextSkin(skin) {
  const index = SKINS.indexOf(skin);
  return SKINS[(index + 1) % SKINS.length];
}
